import { render, staticRenderFns } from "./EditedBy.vue?vue&type=template&id=8448a446&"
import script from "./EditedBy.vue?vue&type=script&lang=js&"
export * from "./EditedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports